import React, { useContext, useState, useEffect } from 'react'
import './viewdoc.css'
import './create.css'
import Sidebar from '../../components/Sidebar/Sidebar'
import QrImg from '../../assets/qr-code.png'
import Sign from '../../assets/signature.png'
import Stamp from '../../assets/stamp.png'
import { ShareContext } from '../../context/ShareContext'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { faPlusCircle, faArrowLeft, faArrowRight,faClose, faRefresh, faWarning, faEdit } from '@fortawesome/free-solid-svg-icons'
import { time } from '../../data/time'
import { useNavigate, useLocation, Link } from 'react-router-dom'
import * as Constants from '../../constants';
import CenterLoader from '../../components/centerLoader'
import BackLoader from '../../components/backloader'
import Seal from '../../assets/seal.png';
import Sign2 from '../../assets/sign.png';
import { Button } from '@mui/material'
import JisPrompt from '../../components/jisprompt'
import JisAlert from '../../components/jisalert'
import TopBar from '../../components/topbar'
import { green, red } from '@mui/material/colors'
import moment from 'moment'


function ViewDocTemplate(props) {
    const { sweared, isCfo, isThirdOpt, setWhichUpload, profile } = useContext(ShareContext)
    var location=useLocation();
  
    var {item} = location.state;
console.log(item);
    const url=`${Constants.apiUrl}/gazette/DocumentTemplateView/${item.id}`;
    const urlSaveInst = `${Constants.apiUrl}/gazette/uploadtemplate/${profile.username}`;
    const urlInstrument=`${Constants.apiUrl}/gazette/instrument/${profile.username}`;
    const [html, setHtml] =useState('');
    const [templates, setTemplate]=useState({});
    const [holders, setHolders] =useState([])
    const [holdervalues, setHolderValues]=useState({});
    const [presentTag, setPresentTag] = useState(new Set());
    const [upload, setUpload] = useState({open:false,title:'', id:0} );

    const pattern= /\[.+?\]/g

    const affidavit_search_prefix='LSJ/HC/AFF';
    const [cfoWarn, setCfoWarn] = useState(false)
    const [isDialog, setIsDialog] = useState(false)
    const [doc, setDocument] =useState({uplines:[],uplinesigns:[]})
    const [currectdoc, setCurrentDoc]=useState({});
    const [uplineIndex, setUplineIndex]=useState(0);
    const [imgIndex, setImageIndex] =useState(0);
    const [isLoading,setIsLoading]= useState(false);
    const [uplineType, setUplineType] = useState('upline'); //upline, sign
    const [posPoint, setPosPoint] = useState({}); //this is for items that are yet added passport 1, Seal 2, Signature 3  {x--cord,y - cord,show bool,docid  instype, imgurl} 
    const [seal, setSeal]=useState('');
    const [passport, setPassport] =useState('');
    const [sign, setSign] =useState('');
    const [initial, setInitial] =useState('');
    const [stamp, setStamp] =useState('');
    
   //load documents first, then load one by one
   const [posId, setPosId] =useState(0); //this is the main guy that is doing the selection
   const [dstart, setDStart]=useState({isDragging: false});
   const [imgs, setImgs]=useState([]);
   const [activeFile,setActiveFile] =useState({});
   const [isSaved, setIsSaved] =useState(true);
   const [allDocCompleted, setAllDocCompleted]=useState(false); //this is to receive the server answer to know when last part is finally treated
   const [activeSub, setActiveSub]=useState({open:false});
   const [refresh, setRefresh]=useState(false);

   const needpermission="Document saved successfully! Wait for the CFO to commission your document ";
   const noneedpermission="Document saved successfully! Wait for the CFO to initial your document";
   const finalmsgcase=`You have worked on all document(s), the case will now move to Process Section Assessors' Queue `;
   const finalmsgaffidavit="You have worked on the affidavit. The process is completed now";

   const permissionList=item.caseType=='adr'?Constants.DocPermissionList_ADR:Constants.DocPermissionList;


   const onSaveInst=()=>{
    if(!upload.isImage)
        return;

        onUploadIns();
   }

   const [imgPrev, setImgPrev]=useState ({data:'', type:'', open:false});

   const [alert, setAlert]=useState ({open:false,title:'', subtitle:''})
   const [prompt, setPrompt]=useState ({open:false,title:'', subtitle:'', isImage:false})

    const navigate = useNavigate()

 const onOk=()=>{
    setAlert({...alert,open:false});
   
 }
 const onOk_Save=()=>{
    setAlert({...alert,open:false});
    if(item.type=='affidavit'){
        navigate("/templates/AffidavitDocuments");
       }
   
 }
 const onCancel=()=>{

 }

  

    const confirmCaseDoc = () => {
        navigate('/upload/documents');
        setWhichUpload('Third')
    }

    useEffect(() => {
        onLoad();
        onLoadInstrument();
      // console.log('am here in usefect');
      }, [item]);

      const onLoad= async()=>{
        //for account registration
        console.log(`the calling url ${url}`);
        try {
            setIsLoading(true);
            const resp = await fetch(url, { 
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': '',
              },
            });
            
            const data = await resp.json();
            setIsLoading(false);
            console.log(data);
            if(data.code==0){
                setDocument(data);
                //load current first item
                setUplineIndex(0);
                var temps={};
                for( const x of data.templates ){
                    temps[x.id]=x;
                 }
                 setTemplate(temps);
                var firstupline=data.uplines[0];
                var ftempid= firstupline.selectedTemplate?.split('|')[0];
               // var htmlstr=atob(temps[ftempid].html);
                var htmlstr=Constants.b64decode(temps[ftempid]?.html);
                 setHtml( htmlstr);
                 if(firstupline.templateJson!=null){
                    //convert to normal json then convert to object
                    const jsonstr=atob(firstupline.templateJson);
                    
                    setHolderValues(JSON.parse(jsonstr));
                 }
                 const tags = Array.from(htmlstr.match(pattern))
                 setPresentTag(new Set( tags ) );

                 /* const tags = Array.from(htmlstr.match(pattern))
                 const uniqtag=Constants.Distinct(tags);
                console.log(uniqtag)
                setPresentTag(new Set( tags ) ); */
                onTemplateHolder(ftempid);

                 setCurrentDoc(firstupline);
setRefresh(true);
            }
            
          } catch (error) {
            setIsLoading(false);
            console.error(error);
            
          }
    }
    const onTemplateHolder= async(tempid)=>{
 
const temprl=`${Constants.apiUrl}/gazette/templates/${tempid}/holders`;
        console.log(`the calling url ${temprl}`);
        try {
            setIsLoading(true);
            const resp = await fetch(temprl, { 
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': '',
              },
            });
            
            const data = await resp.json();
           // console.log(data);
            setIsLoading(false);
            if(data.code==0){
                setHolders(data.holders);
            }
            
          } catch (error) {
            setIsLoading(false);
            console.error(error);
            
          }
    }

    const onNextFile=()=>{
        console.log('on next')
        if( !isSaved){
            setAlert( {...alert, title:'Save Template Data', open:true, subtitle:`Please save by clicking on ${(profile.role== 'LegalCounsel'  || profile.role== 'Customer')? 'Save Document':"Process Document"}. If you do not, all the changes you make will be lost if you perform this operation again.`, onOk })
           setIsSaved(true);
            return;
        }
      //  setIsSaved(false);

        var size=doc.uplines.length;

        //save all selection and overright it with next document
        

        if(uplineIndex < (size-1)){

          
            var a=uplineIndex+1;

            if(doc.uplines[a].selectedTemplate==null){
                //it means not yet assign a template
                setAlert(  {open:true,title:'Document', subtitle:'The next file template not selected.', onOk});
                return;
            }
            setUplineIndex(a);

            setHolders([]);
            var upline=doc.uplines[a];
             var ftempid= upline.selectedTemplate?.split('|')[0];
             //var htmlstr=atob(templates[ftempid].html)
             var htmlstr=Constants.b64decode(templates[ftempid]?.html)
             setHtml(htmlstr );
             const tags = Array.from(htmlstr.match(pattern))
                 setPresentTag(new Set( tags ) );
             if(upline.templateJson!=null){
                //convert to normal json then convert to object
                const jsonstr=atob(upline.templateJson);
                setHolderValues(JSON.parse(jsonstr));
             }else{
                setHolderValues({});
             }
            setCurrentDoc(upline);
            onTemplateHolder(ftempid);
             setRefresh(true);
            onCurrentDoc(upline.id,"upline"); 
            //***** */
         
            
            // end
           


        }else{
           // alert('What you seeing is the last file');
            setAlert(  {open:true,title:'Document', subtitle:'What you seeing is the last file', onOk});
        }
    
        
    }

    const onCurrentDoc= async(id, ftype)=>{ //doctype=upline always this one
        //for account registration DocumentView
        console.log('onCurrentDoc')
        const url=`${Constants.apiUrl}/gazette/singlefile/${id}/${ftype}`
        setIsLoading(true);
        console.log(`the calling url ${url}`);
        try {
            setIsLoading(true);
            const resp = await fetch(url, { 
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': '',
              },
            });
            
            const data = await resp.json();
            setIsLoading(false);
            console.log('specific document');
            console.log(data);
            if(data.code==0 ){
                setCurrentDoc({...data.upline});

                if(data.upline.templateJson!=null){
                    //convert to normal json then convert to object
                    const jsonstr=atob(data.upline.templateJson);
                    
                    setHolderValues(JSON.parse(jsonstr));
                 }
                
            }else if(data.code==1){
                setCurrentDoc(data.upline);
                if(data.upline.templateJson!=null){
                    //convert to normal json then convert to object
                    const jsonstr=atob(data.upline.templateJson);
                    
                    setHolderValues(JSON.parse(jsonstr));
                 }
            }
            
          } catch (error) {
            setIsLoading(false);
            console.error(error);
            
          }
    }

    const onPrevFile=()=>{
        console.log('on next')
        if( !isSaved){
            setAlert( {...alert, title:'Save Template Data', open:true, subtitle:`Please save by clicking on ${(profile.role== 'LegalCounsel' || profile.role== 'Customer')? 'Save Document':"Process Document"}. If you do not, all the changes you make will be lost if you perform this operation again.`, onOk })
           setIsSaved(true);
            return;
        }
       // setIsSaved(false);

       // console.log(uplineIndex);
        if(uplineIndex > 0){

            var a=uplineIndex-1;
            if(doc.uplines[a].selectedTemplate==null){
                //it means not yet assign a template
                setAlert(  {open:true,title:'Document', subtitle:'The next file template not selected.', onOk});
                return;
            }
            setUplineIndex(a);
            setHolders([]);
            var upline=doc.uplines[a];
            var ftempid= upline.selectedTemplate?.split('|')[0];
         //  var  htmlstr=atob(templates[ftempid].html)
         var  htmlstr=Constants.b64decode(templates[ftempid]?.html)
            setHtml(htmlstr );
            const tags = Array.from(htmlstr.match(pattern))
                 setPresentTag(new Set( tags ) );
            if(upline.templateJson!=null){
                //convert to normal json then convert to object
                const jsonstr=atob(upline.templateJson);
                setHolderValues(JSON.parse(jsonstr));
             }else{
                setHolderValues({});
             }
           setCurrentDoc(upline);
           onTemplateHolder(ftempid);
           setRefresh(true);
          // onCurrentDoc(upline.id,"upline"); 
        }else{
            //alert('What you seeing is the first file');
            setAlert(  {open:true,title:'Document', subtitle:'What you seeing is the first file', onOk});
        }
    }


    //drag issue
    const onDrag = (e) => {
        /* dragCarer.current = position;*/
      
        const _start={
            ...dstart, x:e.clientX, y:e.clientY
          }
          setDStart(_start);
        
       
      };

      const scheduleDragEnter = (e,day, position) => {
        // dragOver.current = {day,position};
       
        e.preventDefault();
      };

      
    //passport 1, Seal 2, Signature 3 
 
    const previewImage= async (event)=> {
        console.log("file read");
        const input = event.target;
       // setUpload upload
        console.log(input);
        if (input.files && input.files[0]) {
            var b64=await Constants.toBase64(input.files[0]);
            setUpload({...upload, isImage:true,data:b64, file:input.files[0]})
           

         
        }
      }

  
      const onUploadIns= async()=>{
        console.log('imgPrev data');
        console.log(upload);
     
      
            setIsLoading(true);    
        //setImgPrev({...imgPrev,open:true,data:e.target.result,type:inst, title:"Upload "+inst, });
            var ext=upload.file.name?.split('.')[1];
            var rdata={base64: upload.data?.split(',')[1],ext,holderId:upload.id};
            // Sending the FormData using fetch
            fetch(urlSaveInst, {
            method: 'POST',
            body: JSON.stringify(rdata),
            headers: {
              'Content-Type': 'application/json',
              'Authorization': '',
            },
            })
            .then(response => response.json())
            .then(data => {
                setIsLoading(false); 
                if(data.code==0){
                    //saved already
                   //get the real url and attach to the holdervalues of same id and check if value exist to display instead of displaying default
                   console.log(`the holder  ${upload.id}`)
                   var hv={...holdervalues};
                   var row=hv[upload.id];
                  const filename= `${Constants.docUrl}holdermedia/${data.filename}`
                   if(row==null){
                       hv[upload.id]={...upload.holder, value:filename, type:'media'};
                   }else{
                       hv[upload.id]={...row,  value:filename, };
                   }
                 
                   setHolderValues(hv);
                   console.log(hv);
                   setUpload({open:false})
                   replaceTemplate(hv);
                }
            })
            .catch(error => {
                console.error('Error:', error)
                setIsLoading(false); 
            });
    }

        const onAppendOnServer= async()=>{
            setIsLoading(true);    
            const url = `${Constants.apiUrl}/gazette/appendInstrument/${currectdoc?.id}`;
            var ll=[];
            for( const x of imgs ){
                var l= {InstrumentType: x.instype,x:x.x,y:x.y };
                ll.push(l);
            }
            // Sending the FormData using fetch
            fetch(url, {
            method: 'POST',
            body: JSON.stringify(ll),
            headers: {
            'Content-Type': 'application/json',
            'Authorization': '',
            },
            })
            .then(response => response.json())
            .then(data => {
                setIsLoading(false); 
                if(data.code==0){
                    //saved already
                    setImgPrev({...imgPrev,open:false})
                setAlert( {...alert, title:imgPrev.type, open:true, subtitle:`Saved Append Successfully`, onOk })
                setPrompt({...prompt, open:false, });
                onSetImg(data.instPath,imgPrev.type);
                }
            })
            .catch(error => {
                console.error('Error:', error)
                setIsLoading(false); 
            });
    }

    const onSetImg =(path,type)=>{
        const ct=type.toLowerCase()
        if(ct=='seal'){
            setSeal(  `${Constants.docUrl}instrument/${path}`);
        }else if(ct=='passport'){
            setPassport(  `${Constants.docUrl}instrument/${path}`);
        }else if(ct=='signature'){
            setSign(  `${Constants.docUrl}instrument/${path}`);
        }
        else if(ct=='initial'){
            setInitial(  `${Constants.docUrl}instrument/${path}`);
        }else if(ct=='stamp'){
            setStamp(  `${Constants.docUrl}instrument/${path}`);
        }
    }

    const onRefreshUpline=()=>{
        onCurrentDoc(currectdoc.id,"upline"); 
    }

    const onLoadInstrument= async()=>{
        //for account registration
        console.log(`the calling url ${urlInstrument}`);
        try {
            setIsLoading(true);
            const resp = await fetch(urlInstrument, { 
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': '',
              },
            });
            
            const data = await resp.json();
            setIsLoading(false);
            if(data.code==0){
                //check if it contain any of the items
                console.log(data);
                for( const x of data.inst ){
                    onSetImg(x.instPath, x.instrument)
                }
                
            }
            
          } catch (error) {
            setIsLoading(false);
            console.error(error);
            
          }
    }


    const onAddList =(holder)=>{
        var hv={...holdervalues};
            var row=hv[holder.id];
            if(row.listobj==null){
                row.listobj=[];
            }
            //row.listobj.push(row.value);
            //row.value=''; //empty the content
            console.log(row.value);
            hv[holder.id]={...row,listobj:[...row.listobj,row.value], value:''};
            setHolderValues(hv);
            replaceTemplate(hv);
       
    }
    const onRemoveList=(holder,idx)=>{
        var hv={...holdervalues};
        var row=hv[holder.id];
        
        var list= row.listobj;
        list.splice(idx, 1)
        //row.listobj.push(row.value);
        //row.value=''; //empty the content
      
        hv[holder.id]={...row,listobj:[...list], value:''};
        setHolderValues(hv);
        replaceTemplate(hv);
    }
    const onEditList=(holder,idx)=>{
        var hv={...holdervalues};
        var row=hv[holder.id];
        
        var list= row.listobj;
      
        hv[holder.id]={...row, value:list[idx].value,editindex:idx};
        console.log('something about index '+idx)
        console.log(hv[holder.id]);
        setHolderValues(hv);
        replaceTemplate(hv);
    }

    const onAddPara =(holder)=>{
        
        var hv={...holdervalues};
            var row=hv[holder.id];
     if(row.editindex==null)  {
        if(row.listobj==null){
                row.listobj=[];
            }
           // row.listobj.push(row.value);
            //row.value=''; //empty the content
            console.log(row.value);
            const ovalue={value:row.value,sub:[]}
            hv[holder.id]={...row,listobj:[...row.listobj,ovalue], value:''};
            console.log(hv[holder.id].listobj);
     } else{
        //edit
        row.listobj[row.editindex]={...row.listobj[row.editindex],value:row.value};
        hv[holder.id]={...row, value:'',editindex:null};
     }   
            
            setHolderValues(hv);
            replaceTemplate(hv);
            
    }
    const onAddSubPara =()=>{
//relies on activeSub holder, ind, idx
const idx=activeSub.idx;
console.log(`index of the item ${idx} value to add ${activeSub.value}`)
        var hv={...holdervalues};
            var row=hv[activeSub.holder.id];
            var list= row.listobj;
            var li= list[idx];
            //li.value, li.subs
            if(li.subs==null){
                li.subs=[activeSub.value];
            }else{
                li.subs=[...li.subs,activeSub.value]
            }
            list[idx]={...li,subs:li.subs}
            row={...row,listobj:list}
           
            //row.value=''; //empty the content
            hv[activeSub.holder.id]={...row};
            setHolderValues(hv);
setActiveSub({open:false});
       replaceTemplate(hv);
    }
    const onRemoveSubList=(holder,idx,idxx)=>{
        var hv={...holdervalues};
        var row=hv[holder.id];
        var list= row.listobj;
        var li= list[idx];
        
        li.subs.splice(idxx, 1);
        list[idx]={...li,subs:li.subs}
        row={...row,listobj:list}
       
        //row.value=''; //empty the content
        hv[holder.id]={...row};
       
        setHolderValues(hv);
        replaceTemplate(hv);
    }

    const onAppending=(holder)=>{
        if(holder.type=='UPLOADED MEDIA[SEAL-COMISSIONER]' || holder.type== "UPLOADED MEDIA[SEAL-DEPONENT]"){ //for seal
            if(profile.role== 'LegalCounsel'  || profile.role== 'Customer'){
                if((permissionList.has(currectdoc?.gazetteItemId) || item.type=='affidavit') && !currectdoc?.allowSeal){
                    setAlert(  {open:true,title:'Append ', subtitle:'Wait for the CFO to authorize appending a seal on the document. This approval will be granted during the scheduled virtual call', onOk});
                  return;
                } 
               }else{
                if((permissionList.has(currectdoc?.gazetteItemId) || item.type=='affidavit') && !currectdoc?.allowSeal){
                    setAlert(  {open:true,title:'Append ', subtitle:'Allow Legal Counsel to append seal before you. use the back link and re-open', onOk});
                  return;
                } 
               }
            }
    
            if(holder.type=='UPLOADED MEDIA[SIGNATURE-DEPONENT]' || holder.type=="UPLOADED MEDIA[SIGNATURE-COMISSIONER]"){
                if((permissionList.has(currectdoc?.gazetteItemId) ||  item.type=='affidavit') && !currectdoc?.allowSign){
                    //  setAlert(  {open:true,title:'Append ', subtitle:'Wait for the CFO to authorize appending a signature on the document. This approval will be granted during the scheduled video virtual call". if you are sure the CFO has approved. Please click Next and Previous to the same file to refresh', onOk});
                   setAlert(  {open:true,title:'Append ', subtitle:'Wait for the CFO to authorize appending a signature on the document. This approval will be granted during the scheduled virtual call', onOk});
                    return;
                  } 
            }

        setUpload({open:true, title:holder.name, id:holder.id, holder , isImage:false});
    }

    const returnTag=(holder, ind)=>{
        var hv={...holdervalues};
    if (holder.type=='TEXT[NORMAL]'  ){
        return  <div className="input-create">
        <label htmlFor="doc-title">{holder.name} </label>
        <input type="text"  placeholder={holder.hint} value={onGetValue(holder)} onChange={(e)=> onDirectText(e,holder)} />
    </div>
        

    }else if (holder.type=='TEXT[MULTIPLE-INPUT]'){
        return <div className="input-create">
        <label htmlFor="defendant">{holder.name}</label>
        <div className="btn-input">
            <input type="text"  placeholder={holder.hint} value={onGetValue(holder)} onChange={(e)=> onDirectTextMultiple(e,holder,ind)}/>
            <button onClick={()=>onAddList(holder)}> Add <FontAwesomeIcon icon={faPlusCircle} /></button>
        </div>
        <ul className='temp'>
        {hv[holder.id]!=null && hv[holder.id].listobj?.map((li, idx) => { return (
                                           <li key={idx}> <div className="content">
                                            {li}
                                           
                                           </div>
                                           <div className="action">
                                           <div className="icon" onClick={() => onRemoveList(holder,idx)} >
                                                               <FontAwesomeIcon icon={faClose} />
                                                           </div>
                                           </div></li>
                                
                                        )})}
        </ul>
    </div>
      
    } else if (holder.type=='CFO-DATE' ||holder.type=='[CFO-DATE]' || holder.type=='[COUNSEL-DATE]' || holder.type=='COUNSEL-DATE' || holder.type=='[DATE]'){

        return  <div className="input-create">
        <label htmlFor="doc-title">{holder.name}</label>
        <input type="date"  placeholder={holder.hint} value={onGetValue(ind)} onChange={(e)=> onDirectText(e,holder)} />
    </div>

    } else if (holder.type=='[CFO-DATE-TIME-STAMP]' || holder.type=='CFO-DATE-TIME-STAMP' || holder.type=='[DATE-TIME-STAMP]' ){

        return  <div  className="append">
        <label htmlFor="doc-title" style={{fontWeight:'bold'}}>{holder.name} </label>
        <button onClick={()=>onTimeStamp(holder)} className='planred'>Append Timestamp</button>
    </div>

    }else if (holder.type=='TEXT[LEGAL-COUNSEL-CONTACT]' ||holder.type=='TEXT[DETAIL-AND-SERVICE-ADDRESS-SECTION]'){
        return  <div className="input-create">
        <label htmlFor="doc-title">{holder.name} </label>
        <textarea id="paragraph" placeholder={holder.hint} value={onGetValue(holder)} onChange={(e)=> onDirectText(e,holder)} ></textarea>
    </div>
    }
    else if (holder.type=='TEXT[MULTIPLE-TEXTAREA]' ){
        return <div className="input-create">
        <label htmlFor="paragraph">{holder.name}</label>
        <div className="btn-input">
            <textarea id="paragraph" placeholder={holder.hint} value={onGetValue(holder)} onChange={(e)=> onDirectAreaMultiple(e,holder,ind)}></textarea>
            <button  onClick={()=>onAddPara(holder)}>{Constants.IsNull(holdervalues[holder.id]?.editindex)?'Add':'Update'} 
                <FontAwesomeIcon icon={Constants.IsNull(holdervalues[holder.id]?.editindex) ?faPlusCircle:faEdit} />
                </button>
        </div>
        <ul className='temp'>
            {hv[holder.id]!=null && hv[holder.id].listobj?.map((li, idx) => { return (
                      <li key={idx}>
                        <div className="content">{li.value}
                        <div style={{marginLeft:16, marginRight:16}}>
                        {li.subs!=null && li.subs?.map((sub, idxx) => { return (
                                           <div key={idxx} stlye={{ backgroundColor:'#ccc'}}> <div className="content">
                                           {Constants.getAlphaByNum(idxx+1) }). {sub}
                                           
                                           </div>
                                           <div className="action">
                                           <div className="icon" onClick={() => onRemoveSubList(holder,idx,idxx)} >
                                                               <FontAwesomeIcon icon={faClose} />
                                                           </div>
                                           </div></div>
                                
                                        )})}
                        </div>
                        </div>
                        <div className="action">
                        <div className="icon" style={{marginLeft:16}} onClick={() => onEditList(holder,idx)} >
                                <FontAwesomeIcon icon={faEdit} /> Edit 
                            </div>
                            <div className="icon" style={{marginLeft:16}} onClick={() => onRemoveList(holder,idx)} >
                                <FontAwesomeIcon icon={faClose} /> Del 
                            </div>
                            <div className="icon" style={{marginLeft:16}} onClick={() => setActiveSub({open:true, holder,idx, title:'Sub Paragraph'})} >
                                <FontAwesomeIcon icon={faPlusCircle} />  Sub
                            </div>
                        </div>
                          </li>
                                
             )})}
        </ul>
    </div>
      
    } 
    else if (holder.type=='UPLOADED MEDIA[SIGNATURE-DEPONENT]' ||
     holder.type=='UPLOADED MEDIA[SEAL-COMISSIONER]' || 
     holder.type=='UPLOADED MEDIA[STAMP-COMISSIONER]' || holder.type== 'UPLOADED MEDIA[PASSPORT]' 
     || holder.type== "UPLOADED MEDIA[SEAL-DEPONENT]"
     || holder.type=="UPLOADED MEDIA[SIGNATURE-COMISSIONER]" || (holder.type=="UPLOADED MEDIA[IMAGE]" && (holder.placeHolder!='[QR-CODE]' && holder.placeHolder!='[CASHIER_SEAL]' && holder.placeHolder!='[CASHIER_STAMP]')))
     {
        const ss=checkMedia(holder);
       return <div className="append">
        <img src={ holdervalues[holder.id]==null?  (ss.status?ss.imgPath: Seal): holdervalues[holder.id]?.value} alt="Instrument" style={{width:100}} />
        <div className='buttongrp'>
           {ss.status && <div><button className='black' onClick={()=>onAppendStoreImg(holder,ss.imgPath)}>Use this {ss.type}</button></div>} 
            <div className="append-create"  onClick={() =>onAppending(holder) } >
         
            <label htmlFor="append-seal">{ss.status? `Choose Another ${ss.type}`: holder.name}</label>
        </div>
        </div>
        
    </div>
    } else if (holder.placeHolder=='[QR-CODE]'){
        //AUTO ADDED TO PROJECT. ITS AN IMAGE
        var hv={...holdervalues};
        var row=hv[holder.id];
        if(hv[holder.id]==null){
            console.log('found qrcode within document')
       // var searchlink=`DOC/JS/${item.caseFeeId}/${item.id}/${currectdoc?.id}`; 
        var searchlink=item.type=='affidavit'? `${Constants.baseurl}/search/${affidavit_search_prefix}/${currectdoc?.id}/${retrieveDocYear()}}`:`${Constants.baseurl}/search/${item.caseNumber}/HC/${currectdoc?.id}}`;
        var urlimg = Constants.QrCodelink(searchlink) ;
        onAppendStoreImg(holder,urlimg); //Write qrcode straing
        }
        
    }
    else if (holder.placeHolder=='[CASHIER_SEAL]'){
        //AUTO ADDED TO PROJECT. ITS AN IMAGE
        var hv={...holdervalues};
        var row=hv[holder.id];
        if(hv[holder.id]==null){
            console.log('found qrcode within document')
       // var searchlink=`DOC/JS/${item.caseFeeId}/${item.id}/${currectdoc?.id}`; 
        var cashierlink=`${Constants.rooturl}/resources/special/cashier_seal_${currectdoc?.id}.png`
        var urlimg = cashierlink ;
        onAppendStoreImg(holder,urlimg); //Write qrcode straing
        }
        
    }
    else if (holder.placeHolder=='[CASHIER_STAMP]'){
        //AUTO ADDED TO PROJECT. ITS AN IMAGE
        var hv={...holdervalues};
        var row=hv[holder.id];
        if(hv[holder.id]==null){
            console.log('found qrcode within document')
       // var searchlink=`DOC/JS/${item.caseFeeId}/${item.id}/${currectdoc?.id}`; 
        var cashierlink=`${Constants.rooturl}/resources/special/cashier_stamp.png`
        var urlimg = cashierlink ;
        onAppendStoreImg(holder,urlimg); //Write qrcode straing
        }
        
    }
    else{
       // hv[ind]={value:'', type:'text'}
       // setHolderValues(hv);
        return <div>
           {/*  <span>{holder.id}- {holder.name} - {holder.placeHolder}</span> */}
        <div className="input-create">
        <label htmlFor="doc-title">{holder.name} </label>
        <input type='text' value={onGetValue(ind)} onChange={(e)=> onDirectText(e,holder,ind)} placeholder={holder.hint} />
    </div>
        </div>
    }
    
}



const onAppendStoreImg=(holder, imgpath)=>{
    console.log(`the holder  ${holder.id}`)
    //check which type of item
//if signature, no gree, if seal no gree

    if(holder.type=='UPLOADED MEDIA[SEAL-COMISSIONER]' || holder.type== "UPLOADED MEDIA[SEAL-DEPONENT]"){ //for seal
        if(profile.role== 'LegalCounsel' || profile.role== 'Customer'){
            if((permissionList.has(currectdoc?.gazetteItemId) ||  item.type=='affidavit') && !currectdoc?.allowSeal){
                setAlert(  {open:true,title:'Append ', subtitle:'Wait for the CFO to authorize appending a seal on the document. This approval will be granted during the scheduled virtual call', onOk});
              return;
            } 
           }else{
            if((permissionList.has(currectdoc?.gazetteItemId) ||  item.type=='affidavit') && !currectdoc?.allowSeal){
                setAlert(  {open:true,title:'Append ', subtitle:'Allow Legal Counsel to append seal before you, if you sure you have as CFO then. Please Next and Previous to same file to refresh', onOk});
              return;
            } 
           }
        }

        if(holder.type=='UPLOADED MEDIA[SIGNATURE-DEPONENT]' || holder.type=="UPLOADED MEDIA[SIGNATURE-COMISSIONER]"){
            if((permissionList.has(currectdoc?.gazetteItemId)||  item.type=='affidavit') && !currectdoc?.allowSign){
                //  setAlert(  {open:true,title:'Append ', subtitle:'Wait for the CFO to authorize appending a signature on the document. This approval will be granted during the scheduled video virtual call". if you are sure the CFO has approved. Please click Next and Previous to the same file to refresh', onOk});
               setAlert(  {open:true,title:'Append ', subtitle:'Wait for the CFO to authorize appending a signature on the document. This approval will be granted during the scheduled virtual call', onOk});
                return;
              } 
        }

    var hv={...holdervalues};
    var row=hv[holder.id];
    if(hv[holder.id]==null){
        hv[holder.id]={...holder, value:imgpath, type:'media'};
    }else{
        hv[holder.id]={...row,  value:imgpath, };
    }

    setHolderValues(hv);

     replaceTemplate(hv);
}
const checkMedia=(hh)=>{
    //return object {status: true, imgpath: ''}, or {status:false}
    //seal==''? Seal : seal
    var holdertype=hh.type;
    if(hh.placeHolder=='[CFO_SEAL]' || hh.placeHolder=='[DEPONENT-SEAL]'){
        return {status:seal!='', imgPath: seal, type:'Seal'}; //this will return true if seal contain value else it will return false
    }else if(hh.placeHolder=='[CFO_INITIAL]'){
        return {status:initial!='', imgPath: initial, type:'Initial'};
    }else if(hh.placeHolder=='[CFO_STAMP]'){
        return {status:stamp!='', imgPath: stamp, type:'Stamp'};
    }else if(hh.placeHolder=='[SIGNATURE-DEPONENT]' || hh.placeHolder=='[LEGAL-COUNSEL-SIGNATURE]'){
        //sign==''? Sign:sign
        return {status:sign!='', imgPath: sign, type:'Signature'};
    }
    else if(hh.placeHolder=='[PASSPORT]'){
        return {status:passport!='', imgPath: passport, type:'Passport'};
    }else{
        return {status:false};
    }

}

        const onDirectText = (e,holder)=>{
            console.log(`the holder  ${holder.id}`)
            var str= Constants.ConvertText (e.target.value);
            //var str= e.target.value?.toUpperCase();
            const value= str;
            var hv={...holdervalues};
            var row=hv[holder.id];
            if(hv[holder.id]==null){
                hv[holder.id]={...holder, value:value, type:'single'};
            }else{
                hv[holder.id]={...row,  value:value, };
            }
           
          /*    var ftempid= currectdoc.selectedTemplate.split('|')[0];
             var htmlstr=atob(templates[ftempid].html)
             var rhtml=htmlstr ;//.replace(holder,e.target.value)
 */
            setHolderValues(hv);
            console.log(hv);
           
           /*   var rhtml =Constants.ReplaceAll(rhtml,holder.placeHolder,e.target.value) // rhtml.replace(/i/g, holder.placeHolder);
           // rhtml=rhtml.replace(holder.placeHolder,e.target.value)
             setHtml(rhtml ); */
             replaceTemplate(hv);
             setIsSaved(false);
        }
        const onTimeStamp = (holder)=>{
           // console.log(`the holder  ${holder.id}`)
            var hv={...holdervalues};
            var row=hv[holder.id];
             const currentdate=new Date();
             //console.log(currentdate);
             var tstamp=moment(currentdate).format("YYYY-MM-DD hh:mm a");
            if(hv[holder.id]==null){
             //   console.log('first time here');

                hv[holder.id]={...holder, value:tstamp, type:'single'};
            }else{
              //  console.log(`old value ${hv[holder.id].value} and new value is ${tstamp}` )
                hv[holder.id]={...row,  value:tstamp, };
              //  console.log('another time here');
            }
           
          /*    var ftempid= currectdoc.selectedTemplate.split('|')[0];
             var htmlstr=atob(templates[ftempid].html)
             var rhtml=htmlstr ;//.replace(holder,e.target.value)
 */
            setHolderValues(hv);
           // console.log(hv);
           
           /*   var rhtml =Constants.ReplaceAll(rhtml,holder.placeHolder,e.target.value) // rhtml.replace(/i/g, holder.placeHolder);
           // rhtml=rhtml.replace(holder.placeHolder,e.target.value)
             setHtml(rhtml ); */
             replaceTemplate(hv);
             setIsSaved(false);
        }

        const onDirectTextMultiple = (e,holder)=>{
        
            var hv={...holdervalues};
            const value= Constants.ConvertText(e.target.value?.toUpperCase())
            var row=hv[holder.id];
            if(hv[holder.id]==null){
                hv[holder.id]={...holder, value,  type:'list'};
            }else{
                 hv[holder.id]={...row,  value};
            }
           
            
            setHolderValues(hv);
            setIsSaved(false);
            console.log(hv);

        }

        const onDirectAreaMultiple = (e,holder)=>{
            var hv={...holdervalues};
            var row=hv[holder.id];
            var value=Constants.ConvertText(e.target.value)
            if(hv[holder.id]==null){
                hv[holder.id]={...holder, value,  type:'paragraph'};
            }else{
                 hv[holder.id]={...row,  value};
            }
           
            
            setHolderValues(hv);
            console.log(hv);
            setIsSaved(false);
        }

        const onDirectDate = (e,holder,index)=>{

        }
        const onGetValue=(holder)=>{
            return holdervalues[holder.id]?.value;
        }

        const replaceTemplate=(obj)=>{
            if(currectdoc.selectedTemplate==null)
                return;

            var ftempid= currectdoc.selectedTemplate?.split('|')[0];
             //var htmlstr=atob(templates[ftempid].html)
             var htmlstr=Constants.b64decode(templates[ftempid]?.html)
             var rhtml=htmlstr ;

            for (const ho of Object.values(obj)){
                if(ho.type=='single'){
                    rhtml = Constants.ReplaceAll(rhtml,ho.placeHolder,ho.value) 
                    rhtml= rhtml.replace(/(?:\r\n|\r|\n)/g, '<br>')
                }else if(ho.type=='media'){
                   // var rp=`<table style='width:150px;display:inline'><tr><td><img src='${ho.value}' alt="Seal" style='width:100px' /></td><tr></table>`;
                   var rp=`<img src='${ho.value}' style='width:100px' />`;
                    rhtml = Constants.ReplaceAll(rhtml,ho.placeHolder,rp) 
                }
                else if(ho.type=='list'){
                    if(ho.listobj!=null){
                        var sul='<div style="margin-left:25px; padding:16px">';
                        var idx=0;
                        for(const li of ho.listobj)
                        {
                            idx++;
                            sul+=`<p>${idx}. ${li}</p>`;
                        }
                        sul+='</div>'
                        rhtml = Constants.ReplaceAll(rhtml,ho.placeHolder,sul) ;
                    }

                }else if(ho.type=='paragraph'){
                    if(ho.listobj!=null){
                        var sul='<div style="margin-left:25px; padding:16px">';
                        var idx=0;
                        for(const li of ho.listobj)
                        {
                            idx++;
                            sul+=`<div>${idx}. ${li.value}`

                            if(li.subs!=null)  {
                                var idxx=0;
                              sul+=  '<div style="margin-left:25px;">' 
                                for (const sub of li.subs ){
                                    idxx++;
                                    sul+=`<p>${Constants.getAlphaByNum(idxx) }). ${sub}</p>`;
                                }
                              sul+='</div>'  
                            } 
                            sul+='</div>';
                            
                        }
                        sul+='</div>'
                        rhtml = Constants.ReplaceAll(rhtml,ho.placeHolder,sul) ;
                    }

                }else{

                }
            }
            setHtml(rhtml );
        }

        const onFinalProcess=async()=>{
            //write the txt to pdf
            setIsDialog(false)
            try {
                const theurl=`${Constants.apiUrl}/gazette/saveTemplateData/${currectdoc.id}`;
                setIsLoading(true);
                var strjson=btoa(JSON.stringify(holdervalues)) ;
                var base64 =Constants.b64encode(html); // btoa(html);
                const data={docuplineId:currectdoc.id,htmlstr: base64,jsonstr:strjson, Userid:profile.username, isFinal:true};
                const resp = await fetch(theurl, {
                  method: 'POST',
                  body: JSON.stringify(data),
                  headers: {
                    'Content-Type': 'application/json',
                    'Authorization': '',
                  },
                });
                
                const responseData = await resp.json();
                setIsLoading(false);
                console.log(responseData);
                if (responseData.code === 0 ) {
                   // alert('saved to a pdf file');

                   // setAlert(  {open:true,title:'Template', subtitle:'saved to a pdf file', onOk});

                    if(responseData.incompleted==0){
                        setAlert( {...alert, title:'Process Document', open:true, subtitle: item.type=='affidavit'?finalmsgaffidavit:finalmsgcase, onOk:onIsCompleted })
                    }else{
                        setAlert( {...alert, title:'Process Document', open:true, subtitle:`Processed Successfully. Document remain to be processed ${responseData.incompleted}`, onOk })
                    }

                    setIsSaved(true);
                   // setAllDocCompleted(responseData.isFinal);
                   
                    
                }else {
                    setAlert(  {open:true,title:'Template', subtitle:responseData.status, onOk});
                }
              
              } catch (error) {
                setIsLoading(false);
                console.error(error);
               
              }
        }

        const onSaveDraft =async()=>{
            //write the txt to pdf
            setIsDialog(false)
            //this will save only item added

            try {
                const theurl=`${Constants.apiUrl}/gazette/saveTemplateData/${currectdoc.id}`;
                setIsLoading(true);
                var stfy=JSON.stringify(holdervalues)
                var strjson=btoa(stfy) ;
                console.log('json values of selected values ');
               // console.log(stfy);
                //var strhtml=btoa();

                console.log('possible html to btoa');
               // console.log(html);
                var base64 =btoa(html);
               
                

                const data={docuplineId:currectdoc.id,jsonstr:strjson,htmlstr: base64,  Userid:profile.username,isFinal:false};
                const resp = await fetch(theurl, {
                  method: 'POST',
                  body: JSON.stringify(data),
                  headers: {
                    'Content-Type': 'application/json',
                    'Authorization': '',
                  },
                });
                
                const responseData = await resp.json();
                setIsLoading(false);
                console.log(responseData);
                if (responseData.code === 0 ) {
                   // alert('saved to a pdf file');
                    setAlert(  {open:true,title:'Document', subtitle:(permissionList.has(currectdoc?.gazetteItemId)||  item.type=='affidavit')? needpermission:noneedpermission, onOk:onOk_Save});
                    setIsSaved(true);
                    
                }else {
                    setAlert(  {open:true,title:'Document', subtitle:responseData.status, onOk});
                }

                setIsSaved(true);
              } catch (error) {
                setIsLoading(false);
                console.error(error);
               
              }
        }

        const onProcessAction=()=>{
            //check if all item is entered for on the 
           // holdervalues
           const arrMain=Object.values(holdervalues);
           //compare if holders.length is same figure arrMains
           //arrMain.length== holders.length
           if(profile.role== 'LegalCounsel' || profile.role== 'Customer'){
             //completed but still check 
             onSaveDraft();
             
           }else{
            onFinalProcess();

           }

        }

      const cancelUpload=()=>{
        setUpload({open:false});

      }

      const onSaveMedia =()=>{

      }

      const onIsCompleted=()=>{
        // go to home page, when work is completed
        console.log('is completed')
        setAlert({...alert,open:false});
       // window.location.replace(`${Constants.primarySite}/Users.aspx`)
       if(item.type=='affidavit'){
        navigate("/templates/AffidavitDocuments");
       }else{
        navigate("/home/dashboard")
       }
        
    }

    useEffect(() => {
        replaceTemplate(holdervalues);
     /*  if(refresh){
        setTimeout(function () {
            //setBttnText("COPY CODE");
           
          }, 1000);
       setRefresh(false);
    } */
     }, [html,refresh, holdervalues]); 

     const onAllowSign =(e)=>{
        console.log(e.target.value);
        //setCurrentDoc({...currectdoc,upline.allowSign})
        onAllow(true, 'sign');

    }
    const onAllowSeal =(e)=>{
        console.log(e.target.value);
        onAllow(true, 'seal');
    }

    const onAllow=(isAllow, instType)=>{
        const url=`${Constants.apiUrl}/gazette/allowinstrument/${currectdoc?.id}`;
        var ll={uplineId:currectdoc?.id,isAllow, instType, cfoUserid: profile.username  }
        setIsLoading(true); 
         
            fetch(url, {
            method: 'POST',
            body: JSON.stringify(ll),
            headers: {
            'Content-Type': 'application/json',
            'Authorization': '',
            },
            })
            .then(response => response.json())
            .then(data => {
                setIsLoading(false); 
                if(data.code==0){
                    //saved already
                   if(instType=='seal'){
                   
                    setCurrentDoc({...currectdoc,allowSeal:isAllow})
                   }
                   else if(instType=='sign'){
                    
                    setCurrentDoc({...currectdoc,allowSign:isAllow})
                   }
             

                }
            })
            .catch(error => {
                console.error('Error:', error)
                setIsLoading(false); 
            });
    }

    const retrieveDocYear=()=>{
     return currectdoc?.uploadDate==null ? moment(new Date()).format("YYYY"): moment(currectdoc?.uploadDate).format("YYYY")
    }

  return (
    <div className='view-doc'>
        <Sidebar />
        <div className="body">
            
            <TopBar status="Home/Document-View" />
            <div className="document">
                <div className="doc-side">
                    <div className="top-bar">
                      {item.type!='affidavit' && <button onClick={onPrevFile} className='planred'>Previous Document</button>}  
                        <div className="namedoc">
                            <p>Current File: <span>{currectdoc.selectedTemplate}</span> </p>
                        </div>
                        {item.type!='affidavit' && <button onClick={onNextFile} className='planred'>Next Document</button>}
                    </div>  
                    <div className="wrapper" style={{maxWidth:650, width:'100%', backgroundColor:'white',color:'black', padding:0, position:'relative', overflow:"auto"}}
                     /* onMouseMove={onMoveInstru} onDoubleClick={()=>setPosId(0)} */  >
                      <div style={{width:'100%'}} dangerouslySetInnerHTML={{__html:  html}}></div>
                      
                        {/* {currectdoc.upline!=null && <span>{currectdoc.filenames[0]} <strong>{Constants.AbsoluteFiletoRelative(currectdoc.filenames[0])}</strong></span> } */}
                       {!currectdoc.isTemplate && <h2>You are yet to select Template. Goto the link <Link to={`/upload/documents/${item.caseFeeId}`}><span>Seleted Templates</span> </Link> </h2>}
                 
                    </div>
                </div>
               
                 <div className='actions'>


                    <div className='create-case'>
                        
                        <div className="body">
                            <div className="top-nav">
                                <div className="left-top">
                                    <div className="top">
                                        <h2>Prepare {item.type!='affidavit'?'Case Document':'Affidavit Document'} </h2>
                                        <div className="icon" onClick={onRefreshUpline} >
                                            <FontAwesomeIcon icon={faRefresh} />
                                        </div>
                                    </div>
                                    <p>Please fill in the inputs and append seal and signature  </p>
                                     { (profile.role=='CommissionerForOaths' || profile.role=='e-CFO'|| profile.role=='e-Commissioner for Oaths' || profile.role=='ACR' || profile.role=='e-ACR' )
                                      && (permissionList.has(currectdoc?.gazetteItemId) || item.type=='affidavit') && <div className='check-sign'>
                                        <div>
                                            <input type="checkbox" id='check-cfo' checked={currectdoc?.allowSign} disabled={currectdoc?.allowSign} onChange={(e)=> onAllowSign(e)} />
                                            <label htmlFor="check-cfo" >Allow to Append Signature</label>
                                        </div>
                                        <div>
                                            <input type="checkbox" checked={currectdoc?.allowSeal} id='check-cfo'  disabled={currectdoc?.allowSeal} onChange={(e)=> onAllowSeal(e)}/>
                                            <label htmlFor="check-cfo">Allow to Append Seal</label>
                                        </div>
                        
                                </div> } 
                    
                        {(permissionList.has(currectdoc?.gazetteItemId) || item.type=='affidavit') && 
                        <div>{(currectdoc?.allowSign && currectdoc?.allowSeal)?<span style={{color:green[500], fontWeight:'bold'}}>permission granted for you to append your signature/seal </span> :<span style={{color:red[500], fontWeight:'bold'}}>Permission required for item </span>}</div>}
                   
                                </div>
                                <p className="nav-status"></p>
                            </div>
                            <div className="form">
                                <div className="left-side">
                                   
                                    {holders.length>0 && holders?.map((ho, idx) => { return (
                                        (((profile.role=='LegalCounsel' || profile.role== 'Customer') && !Constants.CFO_Placeholders.has(ho.id)) || !(profile.role=='LegalCounsel' || profile.role== 'Customer') && Constants.CFO_Placeholders.has(ho.id))
                                        &&
                                          //presentTag.has(ho.placeHolder) && 
                                          returnTag(ho, idx)
                                
                                        )})}
                                </div>
                              
                            </div>
                            <div className="down">
                               {/*  <div className="goBack" onClick={() => navigate('/upload') }>
                                    <FontAwesomeIcon icon={faArrowLeft} />
                                    <p>Back to Upload</p>
                                </div> */}
                                <div className="btns">
                                    <button onClick={()=> setIsDialog(true)}
                                    className="upload" 
                                    >
                                       {(profile.role=='LegalCounsel' || profile.role== 'Customer')? 'Save Document':"Process Document"}  <FontAwesomeIcon icon={faArrowRight} />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                   
                    <div className="details">
                        <div className="row">
                            <p className="name">Document Reference ID</p>
                           
                            {item.type=='affidavit'?<p className="answer">{`${affidavit_search_prefix}/${currectdoc?.id}/${retrieveDocYear()}`}</p>: 
                            <p className="answer">{`${item.caseNumber}/HC/${currectdoc?.id}`}</p> }
                        </div>
                        {item.type!='affidavit' && <>
                            <div className="row">
                                <p className="name">Case Title</p>
                                <p className="answer">{item.caseTitle}</p>
                            </div>
                            <div className="row">
                                <p className="name">Case Number</p>
                                <p className="answer">{item.caseNumber}</p>
                            </div>
                            <div className="row">
                                <p className="name">Number of Documents</p>
                                <p className="answer">{doc?.uplines.length }</p>
                            </div>
                            <div className="row">
                                <p className="name">Scheduled for e-Swearing</p>
                                <p className="answer">Yes</p>
                            </div>
                            
                        </>}
                        <div className="row">
                                <p className="name">e-Swearing Schedule Date</p>
                                <p className="answer">{item.schedule==null?'N/A':Constants.formatDate(item.schedule)}</p>
                            </div>
                            <div className="row">
                                <p className="name">e-Swearing Schedule Time</p>
                                <p className="answer">{item.schedule==null?'N/A':Constants.formatTime(item.schedule)}</p>
                            </div>
                            <div className="row">
                                <p className="name">Zoom Link</p>
                                <p className="answer  zoom-link">{item.zoomLink!=null && <a href={item.zoomLink} target='_blank'>{item.zoomLink}</a>} </p>
                            </div>
                           
                    </div>
                    
                    
                    
                </div>
            </div>
            <div className="down">
                <div className="goBack" onClick={() => window.history.back()}>
                    <FontAwesomeIcon icon={faArrowLeft} />
                    <p>Back</p> {/* <a href={`${Constants.docUrl}${currectdoc?.filename}`} target='_blank'>View on Browser</a> */}
                </div>
                {!currectdoc.isTemplate && <Link to={`/upload/documents/${item.caseFeeId}`}><span>Select Template</span> </Link>}
                 
   
                { isThirdOpt && <button onClick={() => confirmCaseDoc()}>Confirm Document</button> }
            </div>
        </div>
      {cfoWarn && <div className={   'warning show' }>
            <div className="container">
                <div className="icon" onClick={() => setCfoWarn(false)}>
                    <FontAwesomeIcon icon={faClose} />
                </div>
                <div className="body">
                    <h3>Appending Signature</h3>
                    <p>You are not allowed to upload your signature yet. Please wait for the Chief for Oath (CFO) authorizes you to upload your signature. In the mean time, you can upload your seal and passport </p>
                    <button onClick={() => setCfoWarn(false)}>Ok</button>
                </div>
            </div>
        </div> }  
     
        <BackLoader open={isLoading}  />
        {alert.open && <JisAlert {...alert} />} 
        <JisPrompt  open={isDialog} onOk={onProcessAction} onCancel={()=>setIsDialog(false)}>
            <p style={{flexDirection:'row', alignContent:'center', alignItems:'center'}}>
           
               {(profile.role=='LegalCounsel' || profile.role== 'Customer')?
               <strong>Are you sure you want to save this template ? You will not be able to amend after the Commissioner for Oaths has worked on it</strong>:
            <strong>Are you sure you want to process this template ?</strong>}

            
            </p>
        </JisPrompt>

       {upload.open && <div className={ "template-pop open" }>
            <div className="upload-wrap">
                <h3>{upload.title}</h3>
                <div className="upload-file-btn">
                    <label htmlFor="upload-input">{ upload.title}</label>
                    <input
                        type="file"
                        id="upload-input"
                        accept="image/*"
                        onChange={previewImage}
                    />
                     {upload.isImage && (
                        <img src={upload.data} style={{height:100}} alt="Uploaded Media" />
                        )}
                </div>  

                <p className="warn">Maximum File Upload: 1mb</p>

             

                <button className='red' onClick={() => cancelUpload()}>Cancel</button>
                <button className="black" onClick={onSaveInst}>Upload</button>
            </div>
        </div>} 

        {activeSub.open && <div className={ "template-pop open" }>
            <div className="upload-wrap">
                <h3>{activeSub.title}</h3>
               
                    
                    <textarea value={activeSub.value} style={{width:'100%', height:100, padding:16}} onChange={(e)=>setActiveSub({...activeSub, value: Constants.ConvertText(e.target.value) })}>
                    </textarea>
                    
                    
               

              

                
                <button className="black" onClick={onAddSubPara}>Add Sub Paragraph</button>
                <button className='red' onClick={() => setActiveSub({open:false})}>Cancel</button>
            </div>
        </div>} 

       {/*  <JisAlert {...alert} /> */}
       {/*  <JisPrompt {...prompt}>
            <h2>{prompt.subtitle}</h2>
        </JisPrompt> */}
    </div>
  )
}

export default ViewDocTemplate